import React from "react"

export const GMapMd = ({ src, title, width, height, frameBorder, allowFullScreen, style }) => (
    <iframe
        title={title || "gmaps"}
        src={src}
        width={width || "100%"}
        height={height || 450}
        frameBorder={frameBorder || 0}
        allowFullScreen={allowFullScreen || ""}
        style={style || { border: 0 }}
    />)